module.exports = __webpack_public_path__ + "img/case_5.ac6ce6c4.png";